module.exports = __webpack_public_path__ + "static/chart-f8d132ffa50b3ed87f4cbc6c3e76f78e.png";